function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getPlatePluginOptions, getSlateClass, getPlatePluginType, getRenderElement, getPlatePluginTypes } from '@udecode/plate-core';
import { getNodeDeserializer, findNode, insertNodes, getBlockAbove } from '@udecode/plate-common';
import { Range, Transforms, Editor, Node } from 'slate';
import { comboboxStore } from '@udecode/plate-combobox';
import { HistoryEditor } from 'slate-history';
var ELEMENT_MENTION_INPUT = 'mention_input';
var ELEMENT_MENTION = 'mention';
var COMBOBOX_TRIGGER_MENTION = '@';
var getMentionDeserialize = function getMentionDeserialize() {
  var pluginKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ELEMENT_MENTION;
  return function (editor) {
    var options = getPlatePluginOptions(editor, pluginKey);
    return {
      element: getNodeDeserializer(_objectSpread({
        type: options.type,
        getNode: function getNode(el) {
          return {
            type: options.type,
            value: el.getAttribute('data-slate-value')
          };
        },
        rules: [{
          className: getSlateClass(options.type)
        }]
      }, options.deserialize))
    };
  };
};
var moveSelectionByOffset = function moveSelectionByOffset(editor, _ref) {
  var _ref$query = _ref.query,
    query = _ref$query === void 0 ? function () {
      return true;
    } : _ref$query;
  return function (event) {
    var selection = editor.selection;
    if (!selection || Range.isExpanded(selection) || !query(editor)) {
      return false;
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      Transforms.move(editor, {
        unit: 'offset',
        reverse: true
      });
      return true;
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      Transforms.move(editor, {
        unit: 'offset'
      });
      return true;
    }
  };
};
var getMentionInputType = function getMentionInputType(editor) {
  return getPlatePluginType(editor, ELEMENT_MENTION_INPUT);
};
var getMentionInputPluginOptions = function getMentionInputPluginOptions(editor) {
  return getPlatePluginOptions(editor, ELEMENT_MENTION_INPUT);
};
var findMentionInput = function findMentionInput(editor, options) {
  return findNode(editor, _objectSpread(_objectSpread({}, options), {}, {
    match: {
      type: getMentionInputType(editor)
    }
  }));
};
var isNodeMentionInput = function isNodeMentionInput(editor, node) {
  return node.type === getMentionInputType(editor);
};
var isSelectionInMentionInput = function isSelectionInMentionInput(editor) {
  return findMentionInput(editor) !== undefined;
};
var removeMentionInput = function removeMentionInput(editor, path) {
  return Editor.withoutNormalizing(editor, function () {
    var _Node$get = Node.get(editor, path),
      trigger = _Node$get.trigger;
    Transforms.insertText(editor, trigger, {
      at: {
        path: [].concat(_toConsumableArray(path), [0]),
        offset: 0
      }
    });
    Transforms.unwrapNodes(editor, {
      at: path
    });
  });
};
var withMention = function withMention(_ref2) {
  var id = _ref2.id,
    trigger = _ref2.trigger;
  return function (editor) {
    var apply = editor.apply,
      insertText = editor.insertText,
      deleteBackward = editor.deleteBackward;
    editor.deleteBackward = function (unit) {
      var currentMentionInput = findMentionInput(editor);
      if (currentMentionInput && Node.string(currentMentionInput[0]) === '') {
        return removeMentionInput(editor, currentMentionInput[1]);
      }
      deleteBackward(unit);
    };
    editor.insertText = function (text) {
      if (isSelectionInMentionInput(editor)) {
        return Transforms.insertText(editor, text);
      }
      if (!editor.selection || text !== trigger) {
        return insertText(text);
      } // Make sure a mention input is created at the beginning of line or after a whitespace

      var previousCharLocation = Editor.before(editor, editor.selection);
      if (previousCharLocation) {
        var previousChar = Editor.string(editor, Editor.range(editor, editor.selection, previousCharLocation));
        if (previousChar !== '' && previousChar !== ' ') {
          return insertText(text);
        }
      }
      insertNodes(editor, {
        type: getMentionInputType(editor),
        children: [{
          text: ''
        }],
        trigger: trigger
      });
    };
    editor.apply = function (operation) {
      if (HistoryEditor.isHistoryEditor(editor) && findMentionInput(editor)) {
        HistoryEditor.withoutSaving(editor, function () {
          return apply(operation);
        });
      } else {
        apply(operation);
      }
      if (operation.type === 'insert_text' || operation.type === 'remove_text') {
        var currentMentionInput = findMentionInput(editor);
        if (currentMentionInput) {
          comboboxStore.set.text(Node.string(currentMentionInput[0]));
        }
      } else if (operation.type === 'set_selection') {
        var _findMentionInput, _findMentionInput2;
        var previousMentionInputPath = Range.isRange(operation.properties) ? (_findMentionInput = findMentionInput(editor, {
          at: operation.properties
        })) === null || _findMentionInput === void 0 ? void 0 : _findMentionInput[1] : undefined;
        var currentMentionInputPath = Range.isRange(operation.newProperties) ? (_findMentionInput2 = findMentionInput(editor, {
          at: operation.newProperties
        })) === null || _findMentionInput2 === void 0 ? void 0 : _findMentionInput2[1] : undefined;
        if (previousMentionInputPath && !currentMentionInputPath) {
          removeMentionInput(editor, previousMentionInputPath);
        }
        if (currentMentionInputPath) {
          comboboxStore.set.targetRange(editor.selection);
        }
      } else if (operation.type === 'insert_node' && isNodeMentionInput(editor, operation.node)) {
        if (operation.node.trigger !== trigger) {
          return;
        }
        comboboxStore.set.open({
          activeId: id,
          text: '',
          targetRange: editor.selection
        });
      } else if (operation.type === 'remove_node' && isNodeMentionInput(editor, operation.node)) {
        if (operation.node.trigger !== trigger) {
          return;
        }
        comboboxStore.set.reset();
      }
    };
    return editor;
  };
};

/**
 * Enables support for autocompleting @mentions.
 */

var createMentionPlugin = function createMentionPlugin() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$pluginKey = _ref3.pluginKey,
    pluginKey = _ref3$pluginKey === void 0 ? ELEMENT_MENTION : _ref3$pluginKey,
    _ref3$trigger = _ref3.trigger,
    trigger = _ref3$trigger === void 0 ? COMBOBOX_TRIGGER_MENTION : _ref3$trigger;
  return {
    pluginKeys: [pluginKey, ELEMENT_MENTION_INPUT],
    renderElement: getRenderElement([pluginKey, ELEMENT_MENTION_INPUT]),
    deserialize: getMentionDeserialize(pluginKey),
    inlineTypes: getPlatePluginTypes([pluginKey, ELEMENT_MENTION_INPUT]),
    voidTypes: getPlatePluginTypes(pluginKey),
    withOverrides: withMention({
      id: pluginKey,
      trigger: trigger
    }),
    onKeyDown: function onKeyDown(editor) {
      return moveSelectionByOffset(editor, {
        query: isSelectionInMentionInput
      });
    }
  };
};

// import { MentionNodeData } from './types';

var getMentionOnSelectItem = function getMentionOnSelectItem() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$pluginKey = _ref4.pluginKey,
    pluginKey = _ref4$pluginKey === void 0 ? ELEMENT_MENTION : _ref4$pluginKey,
    _ref4$createMentionNo = _ref4.createMentionNode,
    createMentionNode = _ref4$createMentionNo === void 0 ? function (item) {
      return {
        value: item.text
      };
    } : _ref4$createMentionNo,
    insertSpaceAfterMention = _ref4.insertSpaceAfterMention;
  return function (editor, item) {
    var _getBlockAbove;
    var targetRange = comboboxStore.get.targetRange();
    if (!targetRange) return;
    var type = getPlatePluginType(editor, pluginKey);
    var pathAbove = (_getBlockAbove = getBlockAbove(editor)) === null || _getBlockAbove === void 0 ? void 0 : _getBlockAbove[1];
    var isBlockEnd = editor.selection && pathAbove && Editor.isEnd(editor, editor.selection.anchor, pathAbove);
    Editor.withoutNormalizing(editor, function () {
      // insert a space to fix the bug
      if (isBlockEnd) {
        Transforms.insertText(editor, ' ');
      } // select the text and insert the element

      Transforms.select(editor, targetRange);
      Transforms.removeNodes(editor, {
        // TODO: replace any
        match: function match(node) {
          return node.type === ELEMENT_MENTION_INPUT;
        }
      });
      insertNodes(editor, _objectSpread({
        type: type,
        children: [{
          text: ''
        }]
      }, createMentionNode(item))); // move the selection after the element

      Transforms.move(editor); // delete the inserted space

      if (isBlockEnd && !insertSpaceAfterMention) {
        Transforms["delete"](editor);
      }
    });
    return comboboxStore.set.reset();
  };
};
export { COMBOBOX_TRIGGER_MENTION, ELEMENT_MENTION, ELEMENT_MENTION_INPUT, createMentionPlugin, findMentionInput, getMentionDeserialize, getMentionInputPluginOptions, getMentionInputType, getMentionOnSelectItem, isNodeMentionInput, isSelectionInMentionInput, moveSelectionByOffset };